import {
    LIST_AUDIENCE_MOTIVES,
    LIST_AUDIENCE_MOTIVES_SUCCESS,
    LIST_AUDIENCE_MOTIVES_ERROR,
    ADD_AUDIENCE_MOTIVES,
    SAVE_AUDIENCE_MOTIVES,
    SAVE_AUDIENCE_MOTIVES_SUCCESS,
    SAVE_AUDIENCE_MOTIVES_ERROR,
    EDIT_AUDIENCE_MOTIVES,
    UPDATE_AUDIENCE_MOTIVES,
    UPDATE_AUDIENCE_MOTIVES_SUCCESS,
    UPDATE_AUDIENCE_MOTIVES_ERROR,
    DELETE_AUDIENCE_MOTIVES,
    DELETE_AUDIENCE_MOTIVES_SUCCESS,
    DELETE_AUDIENCE_MOTIVES_ERROR
} from '../types';

//Cada reducer tiene su propio state
const initialState = {
    audienceMotives: null,
    audienceMotiveSelected: null,
    error: null,
    errorSave: null,
    isEdit: false,
    loading: false,
    loadingSave: false    
}

export default function(state = initialState, action) {
    switch(action.type) {
        case LIST_AUDIENCE_MOTIVES:
            return {
                ...state,
                loading: true
            }
        case LIST_AUDIENCE_MOTIVES_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case LIST_AUDIENCE_MOTIVES_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                audienceMotives: action.payload
            }
        case SAVE_AUDIENCE_MOTIVES:
        case DELETE_AUDIENCE_MOTIVES:
            return {
                ...state,
                isEdit: false,
                loadingSave: true
            }
        case UPDATE_AUDIENCE_MOTIVES:
            return {
                ...state,
                loadingSave: true
            }
        case SAVE_AUDIENCE_MOTIVES_ERROR:
        case UPDATE_AUDIENCE_MOTIVES_ERROR:
        case DELETE_AUDIENCE_MOTIVES_ERROR:
            return {
                ...state,
                loadingSave: false,
                errorSave: action.payload
            }
        case SAVE_AUDIENCE_MOTIVES_SUCCESS:
            return {
                ...state,
                loadingSave: false,
                errorSave: null,
                audienceMotives: [...state.audienceMotives, action.payload]
            }
        case ADD_AUDIENCE_MOTIVES:
            return {
                ...state,
                audienceMotiveSelected: null,
                isEdit: false
            }
        case EDIT_AUDIENCE_MOTIVES:
            return {
                ...state,
                audienceMotiveSelected: action.payload,
                isEdit: true
            }
        case UPDATE_AUDIENCE_MOTIVES_SUCCESS:
        case DELETE_AUDIENCE_MOTIVES_SUCCESS:
            return {
                ...state,
                loadingSave: false,
                errorSave: null,
                audienceMotives: state.audienceMotives.map(audienceMotive => 
                    audienceMotive.id === action.payload.id ? audienceMotive = action.payload : audienceMotive
                ),
                audienceMotiveSelected: null
            }
        // case DELETE_AUDIENCE_MOTIVES_SUCCESS:
        //     return {
        //         ...state,
        //         loadingSave: false,
        //         errorSave: null,
        //         audienceMotives: state.audienceMotives.filter( audienceMotive => audienceMotive.id !== action.payload)
        //     }
        default:
            return state;
    }
}